<template>
    <vs-popup class="gopos-ordr-detail update-order-popup" title="Edit Order" :active.sync="editOrderPopup.isOpen" fullscreen>
        <div id="go-pos-order-detail">
            <div class="go-pos-order-detail">
                <vx-card class="left-content">
                    <h4 class="font-bold text-2xl mb-6">Order OD{{ orderDetail.id }}</h4>
                    <div class="flex category-service-block">
                        <div class="w-1/3 category-block">
                            <div class="text-lg font-extrabold rounded-item my-2 category-item" v-for="(category, index) in categoryList" :key="index" :style="`background-color: ${category.color_code ? category.color_code : '#9e9e9e'}`"
                                @click="goToCategory(category)">
                                <p>{{ category.name }}</p>
                            </div>
                        </div>
                        <div class="service-block" v-if="!active_category || active_category.type != 'gift_card'">
                            <div class="con-input-search vs-table--search m-0 w-full mb-4" style="max-width: unset">
                                <input type="text" class="input-search vs-table--search-input rounded-item border-custom border-color-custom py-3 text-sm w-full" @input="searchService" placeholder="Search service...">
                                <i class="vs-icon notranslate icon-scale material-icons null">search</i>
                            </div>
                            <div class="service-list-by-category">
                                <div v-if="categoryList.length > 0">
                                    <div v-for="(category, index) in categoryList" :key="index">
                                        <div :id="`category-${category.id}`" v-if="category.items && category.items.length > 0">
                                            <p class="text-xl text-black font-extrabold py-3">{{ category.name }}</p>
                                            <div class="service-list">
                                                <div class="text-lg font-bold mb-3 service-item" v-for="(service, i) in category.items" :key="i" :style="`background-color: ${category.color_code ? category.color_code : '#9e9e9e'}`"
                                                    @click="selectService(service, category)">
                                                    <div class="service-name">
                                                        <p>{{ service.name }}</p>
                                                    </div>
                                                    <div class="service-price">${{ service.price || 0 }}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="p-6 flex-center" v-else>No data available</div>
                            </div>
                        </div>
                        <div class="gift-card-content" v-else>
                            <update-order-gift-card-content @addGiftCard="addGiftCard" :key="gift_card_key"></update-order-gift-card-content>
                        </div>
                    </div>
                </vx-card>

                <vx-card class="right-content">
                    <div class="mb-3">
                        <div class="flex mx-2">
                            <div class="customer-name-group">
                                <div class="tooltip">
                                    <vs-button class="mr-3 customer-name" @click.stop>
                                    {{this.orderDetail.customer_name}}
                                    </vs-button>
                                    <span class="tooltiptext" style="word-wrap: break-word; word-break: break-word;">{{this.orderDetail.customer_name}}</span>
                                </div>
                                <div class="flex text-grey-custom text-sm mt-1" v-if="this.orderDetail.customer_phone != null">
                                    <feather-icon icon="PhoneIcon" svgClasses="h-4 w-4 font-bold mr-1" />
                                    {{StringHelper.phoneNumberFormat(this.orderDetail.customer_phone)}}
                                </div>
                                <div class="flex text-grey-custom text-sm mt-1" v-else>
                                    <feather-icon icon="PhoneIcon" svgClasses="h-4 w-4 font-bold mr-1" />
                                    Unknown
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="mb-3">
                        <div class="vx-row mx-2 point-visit-time">
                            <div class="vx-col w-6/24 mb-2 p-0">
                                <div class="text-sm text-grey-custom">Points</div>
                                <p class="text-sm p-0 pt-1">{{this.orderDetail.current_point}} Pts</p>
                            </div>
                            <div class="vx-col w-6/24 mb-2 p-0">
                                <div class="text-sm text-grey-custom">Visit</div>
                                <p class="text-sm p-0 pt-1" v-if="this.orderDetail.visit_count > 1">{{this.orderDetail.visit_count}} times</p>
                                <p class="text-sm p-0 pt-1" v-else>{{this.orderDetail.visit_count}} time</p>
                            </div>
                            <div class="vx-col w-12/24 mb-2 p-0">
                                <div class="text-sm text-grey-custom">Check in</div>
                                <p class="text-sm p-0 pt-1">{{changeFormat(this.orderDetail.created_at)}}</p>
                            </div>
                        </div>
                    </div>

                    <div class="selected-list text-custom-font" :class="{ 'has-service-fee': calculatedInfo.service_fee, 'has-refunded': true }">
                        <div class="h-full overflow-y-auto px-3">
                            <div class="selected-item-card" v-for="(item, index) in order_items" :key="index">
                                <div class="border-bottom-custom pb-2">
                                    <div class="flex justify-between">
                                        <div class="flex align-center text-xl font-bold color-black">
                                            <span v-if="item.staff_name != null">{{item.staff_name}}</span>
                                            <span v-else>No name</span>
                                        </div>
                                    </div>
                                    <div class="flex justify-between pt-1" v-for="(item, i) in item.items" :key="i">
                                        <div class="flex justify-between w-full">
                                            <p>{{ item.quantity }} x <span v-if="item.combo_name != null">{{ item.combo_name }}: </span> {{ item.item_name }}</p>
                                            <p class="text-primary cursor-pointer" @click="editPrice(item, i)">${{parseFloat(item.price || 0).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}}</p>
                                        </div>
                                        <feather-icon icon="XIcon" svgClasses="w-5 h-5 stroke-current text-danger ml-2 cursor-pointer" @click="removeItem(index, i)" />
                                    </div>
                                </div>
                                <div>
                                    <div class="flex justify-between text-primary-light pt-2 font-bold">
                                        <div class="flex justify-between w-full">
                                            <p>Sub Total</p>
                                            <p>${{ getSubTotal(item) }}</p>
                                        </div>
                                        <feather-icon icon="XIcon" svgClasses="w-5 h-5 stroke-current text-danger ml-2 cursor-pointer visibility-hidden" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="subtotal-group text-custom-font">
                        <div class="flex justify-between color-black font-bold pt-1_5">
                            <p>Sub-total:</p>
                            <p>${{ formatNumber(calculatedInfo.total_before_discount) }}</p>
                        </div>

                        <div class="flex justify-between color-black font-bold pt-1_5">
                            <p>Gift card price:</p>
                            <p>${{ formatNumber(calculatedInfo.gift_card_price) }}</p>
                        </div>

                        <div class="flex justify-between color-black font-bold pt-1_5">
                            <p>Promotion:</p>
                            <p>${{ formatNumber(calculatedInfo.promotion) }}</p>
                        </div>

                        <div class="flex justify-between color-black font-bold pt-1_5">
                            <p>Redeem:</p>
                            <p>${{ formatNumber(calculatedInfo.redeem) }}</p>
                        </div>

                        <div class="flex justify-between color-black font-bold pt-1_5">
                            <p>Cash discount:</p>
                            <p>${{ formatNumber(calculatedInfo.total_cash_discount) }}</p>
                        </div>

                        <div class="flex justify-between color-black font-bold pt-1_5">
                            <p>TAX:</p>
                            <p>${{ formatNumber(calculatedInfo.tax) }}</p>
                        </div>

                        <div class="flex justify-between color-black font-bold pt-1_5" v-if="calculatedInfo.service_fee">
                            <p>Service fee:</p>
                            <p>${{ formatNumber(calculatedInfo.service_fee) }}</p>
                        </div>

                        <div class="flex justify-between color-black font-bold pt-1_5">
                            <p>Tip:</p>
                            <p>${{ formatNumber(calculatedInfo.tip) }}</p>
                        </div>
                    </div>

                    <div class="flex justify-between text-primary-light font-bold total-group text-custom-font pt-3">
                        <p>TOTAL</p>
                        <p>${{ formatNumber(calculatedInfo.total) }}</p>
                    </div>

                    <vs-button class="w-full mt-2" @click="saveUpdateOrder">CONFIRM</vs-button>
                </vx-card>
            </div>
        </div>
        <update-order-staff-popup :active_data="active_data" :editOrderStaffPopup="editOrderStaffPopup" @completeSelect="completeSelect"></update-order-staff-popup>
        <create-custom-item-popup :popupConfig="createCustomItemPopup" @getCustomItem="getCustomItem"></create-custom-item-popup>
        <update-price-popup :item_data="active_price_item" :popupConfig="editPricePopup" @changePrice="changePrice"></update-price-popup>
    </vs-popup>
</template>

<script>
import { StringHelper } from "../../models/string_helper";
import { changeFormatWithDateTime } from '../../helper/datetimeHelper';
export default {
    name: "update-order-popup",
    props: {
        editOrderPopup: {
            type: Object,
            required: true
        },
        order_id: {
            type: Number
        }
    },
    data() {
        return {
            StringHelper,
            order_items: [],
            search: "",
            editOrderStaffPopup: { isOpen: false },
            active_category: null,
            active_data: {},
            editPricePopup: { isOpen: false },
            active_price_item: {},
            createCustomItemPopup: { isOpen: false },
            action_type: "",
            isOpenLoading: false,
            calculated: false,
            gift_card_key: 0
        }
    },
    watch: {
        editOrderPopup: {
            immediate: true,
            deep: true,
            handler() {
                if(this.editOrderPopup && this.editOrderPopup.isOpen) {
                    this.initData();
                }
            }
        },
        // calculatedInfo: {
        //     immediate: true,
        //     deep: true,
        //     handler() {
        //         console.log(this.calculatedInfo);
        //     }
        // }
        order_items: {
            immediate: true,
            deep: true,
            handler() {
                console.log('this.order_items: ', this.order_items);
            }
        }
    },
    methods: {
        openLoadingInDiv(){
            this.$vs.loading({
                container: '#app',
                scale: 0.8
            })
            if(this.loadTime){
                clearTimeout(this.loadTime);
                this.loadTime = null;
            }
            this.isOpenLoading = true;
            this.loadTime = setTimeout( ()=> {
                if(this.isOpenLoading) {
                    this.closeLoading();
                    this.$vs.dialog({
                        color: 'danger',
                        title: 'Notification',
                        text: this.action_type + ' failed',
                        acceptText: 'OK'
                    })
                }
            }, 10000);
        },
        closeLoading() {
            this.$vs.loading.close('#app > .con-vs-loading');
            this.isOpenLoading = false;
        },
        initData() {
            let order_items = [];
            console.log("this.orderDetail: ", this.orderDetail);
            if(this.orderDetail && this.orderDetail.order_items && this.orderDetail.order_items.length > 0) {
                for(let i = 0; i < this.orderDetail.order_items.length; i++) {
                    let order_item = this.orderDetail.order_items[i];
                    let item = {
                        id: order_item.id,
                        order_id: order_item.order_id,
                        staff_id: order_item.staff_id,
                        staff_name: order_item.staff_name
                    };
                    let items = [];
                    if(order_item.items && order_item.items.length > 0) {
                        items = order_item.items.map((item) => { return { ...item } });
                    }
                    item.items = items;
                    order_items.push(item);
                }
            }
            this.order_items = order_items;
            this.active_category = null;
            this.search = "";
            this.active_data = {};
            this.active_price_item = {};
            this.calculated = false;
        },
        changeFormat(day){
            if(day) {
                return changeFormatWithDateTime(day);
            } else {
                return 'N/A';
            }
        },
        removeItem(order_index, item_index) {
            if(this.order_items && this.order_items[order_index] && this.order_items[order_index].items[item_index]) {
                let item = this.order_items[order_index].items[item_index];
                // console.log(item);
                if(item.combo_name) {
                    let combo_name = item.combo_name;
                    for(let i = 0; i < this.order_items.length;) {
                        for(let j = 0; j < this.order_items[i].items.length;) {
                            if(this.order_items[i].items[j].combo_name == combo_name) {
                                this.order_items[i].items.splice(j, 1);
                            } else {
                                j++;
                            }
                        }

                        if(this.order_items[i].items.length == 0) {
                            this.order_items.splice(i, 1);
                        } else {
                            i++;
                        }
                    }
                } else {
                    this.order_items[order_index].items.splice(item_index, 1);
                    if(this.order_items[order_index].items.length == 0) {
                        this.order_items.splice(order_index, 1);
                    }
                }
            }
            this.calculateOrder();
        },
        searchService({target}) {
            this.search = target.value; 
        },
        goToCategory(category) {
            if(category && category.id) {
                this.active_category = category;
                let elem = document.getElementById(`category-${category.id}`);
                if(elem) {
                    elem.scrollIntoView({ block: 'start',  behavior: 'smooth' });
                }

                if(category.type == "custom") {
                    this.createCustomItemPopup.isOpen = true;
                }
            }
        },
        selectService(service, category) {
            this.active_data = {
                service: service,
                category: category
            }
            this.editOrderStaffPopup.isOpen = true;
        },
        completeSelect(data) {
            if(this.order_items && data) {
                for(let i = 0; i < data.length; i++) {
                    let staff_index = -1;
                    for(let j = 0; j < this.order_items.length; j++) {
                        if(data[i].staff_id == this.order_items[j].staff_id) {
                            staff_index = j;
                            j = this.order_items.length;
                        }
                    }

                    if(staff_index != -1) {
                        if(!data[i].item_type) {
                            this.order_items[staff_index].items.push(data[i]);
                            this.calculateOrder();
                            return;
                        }
                        if(this.order_items[staff_index].items) {
                            let item_index = -1;
                            for(let j = 0; j < this.order_items[staff_index].items.length; j++) {
                                if(data[i].item_id == this.order_items[staff_index].items[j].item_id && data[i].combo_name == this.order_items[staff_index].items[j].combo_name) {
                                    item_index = j;
                                    j = this.order_items[staff_index].items.length;
                                }
                            }
                            if(item_index != -1) {
                                this.order_items[staff_index].items[item_index].quantity++;
                                this.order_items[staff_index].items[item_index].price = parseFloat(this.order_items[staff_index].items[item_index].price) + parseFloat(data[i].price);
                            } else {
                                this.order_items[staff_index].items.push(data[i]);
                            }
                        }
                    } else {
                        this.order_items.push({
                            items: [{ ...data[i] }],
                            staff_id: data[i].staff_id,
                            staff_name: data[i].staff_name
                        });
                    }
                }
            }
            this.calculateOrder();
        },
        editPrice(item, index) {
            this.active_price_item = { ...item, index };
            this.editPricePopup.isOpen = true;
        },
        changePrice(data) {
            for(let i = 0; i < this.order_items.length; i++) {
                if(this.order_items[i].staff_id == data.staff_id) {
                    if(this.order_items[i].items[data.index]) {
                        this.order_items[i].items[data.index].price = data.new_price;
                        break;
                    }
                }
            }
            this.editPricePopup.isOpen = false;
            this.calculateOrder();
        },
        formatNumber(value) {
            return value ? parseFloat(value).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') : '0';
            // return value ? +(Math.round(value + "e+2") + "e-2") : 0;
        },
        getSubTotal(item) {
            let result = 0;
            if(item && item.items && item.items.length > 0) {
                for(let i = 0; i < item.items.length; i++) {
                    result += parseFloat(item.items[i].price || 0);
                }
            }
            return this.formatNumber(result);
        },
        getCustomItem(item) {
            this.active_data = {
                service: item,
                category: this.active_category
            }
            this.editOrderStaffPopup.isOpen = true;
        },
        addGiftCard(item) {
            this.active_data = {
                service: item,
                category: this.active_category
            }
            this.editOrderStaffPopup.isOpen = true;
        },
        calculateOrder() {
            let obj = {
                order_id: this.orderDetail.id,
            }
            let total_service = 0;
            let total_product = 0;
            let total_giftcard = 0;
            // console.log(this.order_items);
            if(this.order_items && this.order_items.length > 0) {
                for(let i = 0; i < this.order_items.length; i++) {
                    if(this.order_items[i].items && this.order_items[i].items.length > 0) {
                        for(let j = 0; j < this.order_items[i].items.length; j++) {
                            if(this.order_items[i].items[j].item_type == 1 || this.order_items[i].items[j].item_type == 3 || this.order_items[i].items[j].item_type == 0) {
                                total_service += parseFloat(this.order_items[i].items[j].price || 0);
                            } else if(this.order_items[i].items[j].item_type == 2) {
                                total_product += parseFloat(this.order_items[i].items[j].price || 0);
                            } else if(this.order_items[i].items[j].item_type == 4) {
                                total_giftcard += parseFloat(this.order_items[i].items[j].price || 0);
                            }
                        }
                    }
                }
            }

            obj.total_service = total_service;
            obj.total_product = total_product;
            obj.total_giftcard = total_giftcard;
            // console.log(obj);
            this.action_type = "Calculate order";
            this.openLoadingInDiv();
            this.$store.dispatch("goPos/CALCULATE_ORDER", obj).then(() => {
                this.calculated = true;
                this.closeLoading();
            })
            this.gift_card_key++;
        },
        saveUpdateOrder() {
            let service_list = [];
            if(this.order_items && this.order_items.length > 0) {
                for(let i = 0; i < this.order_items.length; i++) {
                    let order_item = this.order_items[i];
                    if(order_item.items && order_item.items.length > 0) {
                        for(let j = 0; j < order_item.items.length; j++) {
                            let item = {
                                order_id: this.orderDetail.id,
                                item_type: order_item.items[j].item_type == 0 ? 1 : order_item.items[j].item_type,
                                item_id: order_item.items[j].item_id != undefined ? order_item.items[j].item_id : null,
                                item_name: order_item.items[j].item_name,
                                staff_id: order_item.items[j].staff_id,
                                price: parseFloat(order_item.items[j].price),
                                quantity: order_item.items[j].quantity,
                                value: order_item.items[j].giftcard_value ? parseFloat(order_item.items[j].giftcard_value) : 0,
                                combo_id: order_item.items[j].combo_id
                            }
                            service_list.push(item);
                        }
                    }
                }
            }

            let order_data = { ...this.orderDetail };
            order_data.total_before_discount = this.calculatedInfo.total_before_discount;
            order_data.total_after_discount = this.calculatedInfo.total_after_discount;
            order_data.gift_card_price = this.calculatedInfo.gift_card_price;
            order_data.total_cash_discount = this.calculatedInfo.total_cash_discount;
            order_data.service_fee = this.calculatedInfo.service_fee;
            order_data.tax = this.calculatedInfo.tax;
            order_data.change = this.calculatedInfo.change;

            let obj = {
                // order: JSON.stringify(this.orderDetail),
                order: JSON.stringify(order_data),
                insight_id: 0,
                list_service: JSON.stringify(service_list)
            }
            let insight_id = localStorage.getItem("insight_id");
            if(insight_id != null && insight_id != undefined && insight_id != "") {
                obj.insight_id = insight_id;
            }
            
            console.log(obj);
            this.action_type = "Update order";
            this.openLoadingInDiv();
            this.$store.dispatch("goPos/UPDATE_ORDER", obj).then(() => {
                this.closeLoading();
                this.$vs.notify({
                    title:'Notification',
                    text:'Update order success',
                    color:'success',
                    position:'top-right'
                });
                this.$emit("UpdateComplete", this.orderDetail.id);
            })
        }
    },
    computed: {
        categoryList() {
            return this.$store.getters["serviceList/fullCategoryServiceListWithSearch"](this.search);
        },
        orderDetail() {
            return this.$store.state.goPos.orderDetail;
        },
        calculatedOrder() {
            return this.$store.getters["goPos/calculatedOrder"];
        },
        calculatedInfo() {
            let promotion = 0;
            let redeem = 0;
            if(this.calculated) {
                console.log(this.calculatedOrder);
                if(this.calculatedOrder.order_discount && this.calculatedOrder.order_discount.length > 0) {
                    for(let i = 0; i < this.calculatedOrder.order_discount.length; i++) {
                        if(this.calculatedOrder.order_discount[i].item_type == 'customer_campaign') {
                            promotion = this.calculatedOrder.order_discount[i].total_discount;
                        }
                        if(this.calculatedOrder.order_discount[i].item_type == 'reward') {
                            redeem = this.calculatedOrder.order_discount[i].total_discount;
                        }
                    }
                }
                return {
                    total_before_discount: this.calculatedOrder.total_before_discount,
                    gift_card_price: this.calculatedOrder.gift_card_price,
                    promotion: promotion,
                    redeem: redeem,
                    total_cash_discount: this.calculatedOrder.total_cash_discount,
                    service_fee: this.calculatedOrder.service_fee,
                    tax: this.calculatedOrder.tax,
                    tip: this.calculatedOrder.order_tip ? this.calculatedOrder.order_tip.total_tip : 0,
                    total_after_discount: this.calculatedOrder.total_after_discount,
                    // total: parseFloat(this.calculatedOrder.total || 0) + parseFloat((this.calculatedOrder.order_tip && this.calculatedOrder.order_tip.total_tip) || 0) 
                    total: parseFloat(this.calculatedOrder.total || 0),
                    change: this.calculatedOrder.change
                }
            } else {
                if(this.orderDetail.order_discount && this.orderDetail.order_discount.length > 0) {
                    for(let i = 0; i < this.orderDetail.order_discount.length; i++) {
                        if(this.orderDetail.order_discount[i].item_type == 'customer_campaign') {
                            promotion = this.orderDetail.order_discount[i].total_discount;
                        }
                        if(this.orderDetail.order_discount[i].item_type == 'reward') {
                            redeem = this.orderDetail.order_discount[i].total_discount;
                        }
                    }
                }
                return {
                    total_before_discount: this.orderDetail.total_before_discount,
                    gift_card_price: this.orderDetail.gift_card_price,
                    promotion: promotion,
                    redeem: redeem,
                    total_cash_discount: this.orderDetail.total_cash_discount,
                    service_fee: this.orderDetail.service_fee,
                    tax: this.orderDetail.tax,
                    tip: this.orderDetail.tip ? this.orderDetail.tip.total_tip : 0,
                    total_after_discount: this.orderDetail.total_after_discount,
                    total: parseFloat(this.orderDetail.total_after_discount || 0) + parseFloat((this.orderDetail.tip && this.orderDetail.tip.total_tip) || 0),
                    change: 0
                }
            }
        }
    },
    created() {
        this.$store.dispatch("serviceList/GET_FULL_CATEGORY_SERVICE_LIST");
    }
}
</script>